import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserPlus, UserCheck, Clock, Check, X, Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { successPop } from "@/lib/celebrate";
import { api, formatErr } from "@/lib/api";

const btn = "h-10 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 transition-colors disabled:opacity-60";

export function FriendButton({ userId, onChange, noMessage = false }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/friends/status/${userId}`).then(({ data }) => setSt(data)).catch(() => {}); }, [userId]);

  const run = async (fn, msg) => {
    setBusy(true);
    try { const { data } = await fn(); setSt(data); onChange?.(); if (msg) toast.success(msg(data)); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const request = () => run(() => api.post(`/friends/${userId}/request`), (d) => (d.status === "friends" ? "Ihr seid jetzt Freunde 💞" : "Freundschaftsanfrage gesendet"));
  const remove = (msg) => run(() => api.delete(`/friends/${userId}`), () => msg);
  const accept = () => run(() => api.post(`/friends/requests/${st.request_id}/accept`).then((r) => { successPop(); return r; }), () => "Ihr seid jetzt Freunde 💞");
  const decline = () => run(() => api.post(`/friends/requests/${st.request_id}/decline`), () => "Anfrage abgelehnt");

  if (!st) return <div className={`${btn} bg-slate-100`}><Loader2 className="w-4 h-4 animate-spin text-slate-400" /></div>;
  const spin = busy && <Loader2 className="w-4 h-4 animate-spin" />;
  if (st.status === "incoming") return (
    <div className="grid grid-cols-2 gap-2" data-testid="friend-incoming">
      <button onClick={accept} disabled={busy} data-testid="friend-accept-btn" className={`${btn} pink-gradient text-white`}>{spin || <Check className="w-4 h-4" />} Annehmen</button>
      <button onClick={decline} disabled={busy} data-testid="friend-decline-btn" className={`${btn} bg-slate-100 hover:bg-slate-200`}><X className="w-4 h-4" /> Ablehnen</button>
    </div>
  );
  if (st.status === "friends") return (
    <div className={noMessage ? "" : "grid grid-cols-2 gap-2"}>
    {!noMessage && <Link to={`/nachrichten/${userId}`} data-testid="friend-message-btn" className={`${btn} pink-gradient text-white`}><Mail className="w-4 h-4" /> Nachricht</Link>}
    <button onClick={() => window.confirm("Freundschaft wirklich beenden?") && remove("Freundschaft beendet")} disabled={busy} data-testid="friend-remove-btn"
      className={`${btn} w-full bg-emerald-50 text-emerald-700 hover:bg-red-50 hover:text-red-600 group`}>
      {spin || <UserCheck className="w-4 h-4" />} <span className="group-hover:hidden">Befreundet</span><span className="hidden group-hover:inline">Beenden</span>
    </button>
    </div>
  );
  if (st.status === "outgoing") return (
    <button onClick={() => remove("Anfrage zurückgezogen")} disabled={busy} data-testid="friend-cancel-btn" className={`${btn} w-full bg-slate-100 hover:bg-slate-200 text-slate-600`}>
      {spin || <Clock className="w-4 h-4" />} Anfrage gesendet · zurückziehen
    </button>
  );
  return <button onClick={request} disabled={busy} data-testid="friend-add-btn" className={`${btn} w-full pink-gradient text-white`}>{spin || <UserPlus className="w-4 h-4" />} Freund hinzufügen</button>;
}
